/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 var links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
     if (links[i].hostname !== window.location.hostname) {
         links[i].target = '_blank';
         links[i].rel = 'noreferrer noopener';
     }
 }

 function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                // observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

// waitForElm('#bablicFlagsWidget').then((elm) => {
//     if (screen.orientation.type == "landscape-primary") {
//         elm.style.right = "220px";
//         elm.style.zIndex = 5;
//     } else {
//         elm.style.position = "fixed";
//         elm.style.right = "115px";
//         elm.style.top = "17px";
//         elm.style.zIndex = 5;
//     }
// });

waitForElm('#effectiveAppsEgwGiftMessageTextATC').then((elm) => {
    elm.style.width = "100%";
});

if (Shopify.locale == "en")  {
    waitForElm('#effectiveAppsEgwGiftMessageTextATC').then((elm) => {
        elm.setAttribute("placeholder", "Your text")

        var text = document.getElementById("effectiveAppsEgwGiftMessageRCATC").innerHTML;
        var split_text = text.split(":");
        document.getElementById("effectiveAppsEgwGiftMessageRCATC").innerHTML = "Remaining letters:" + split_text[1];
        var mySpans = document.getElementsByTagName("span");
        for(var i=0;i<mySpans.length;i++){
            if(mySpans[i].innerHTML == 'Produkt mit Gravur personalisieren.'){
                console.log("+-+-+-+");
                mySpans[i].innerHTML = "Personalize the product with engraving.";
            }
        }
    });
}

if (Shopify.locale == "fr")  {
    waitForElm('#effectiveAppsEgwGiftMessageTextATC').then((elm) => {
        elm.setAttribute("placeholder", "Ton texte")

        var text = document.getElementById("effectiveAppsEgwGiftMessageRCATC").innerHTML;
        var split_text = text.split(":");
        document.getElementById("effectiveAppsEgwGiftMessageRCATC").innerHTML = "Lettres restantes:" + split_text[1];
        var mySpans = document.getElementsByTagName("span");
        for(var i=0;i<mySpans.length;i++){
            if(mySpans[i].innerHTML == 'Produkt mit Gravur personalisieren.'){
                mySpans[i].innerHTML = "Personnalisez le produit avec une gravure.";
            }
        }
    });
}

// function flashElement(el, times, speed, defColor, color) {
//     if (speed == undefined) {
//         var speed = 200;
//     }
//     if (defColor == undefined) {
//         var defColor = $(el).css("backgroundColor");
//     }
//     if (color == undefined) {
//         var color = "#FFFF9C";
//     }
//     //Stop any previous animations.
//     $(el).stop();
//     flashElement_process(el, times, color, defColor, speed);
// }
// function flashElement_process(el, times, color, defColor, speed) {
//     if (times > 0) {
//         $(el).animate({ backgroundColor: color}, speed, function() {
//             $(el).animate({ backgroundColor: defColor }, speed, function() {
//             //one flash done
//             flashElement_process(el, times-1, color, defColor, speed);
//             });
//         });
//     }
// }

let scrollToBottom = document.querySelector("#scroll-to-bottom")
let pageBottom = document.querySelector("#scroll-to-bottom-footer")
let footerFlash = document.querySelector("#footer-flash")

scrollToBottom.addEventListener("click", function() {
    pageBottom.scrollIntoView({ behavior: 'smooth' })
    // flashElement(footerFlash, 3, 300, "#ecec92", "#FFFFFF")
    footerFlash.style.backgroundColor = "#ecec92"
})